export * from './Abilities'
export * from './AccuracyFaultModal'
export * from './BottomModal'
export * from './Chart'
export * from './Checkbox'
export * from './CropImage'
export * from './DefaultLinkButton'
export * from './DeleteChildModal'
export * from './Doctor'
export * from './EstimatedTime'
export * from './ProgressionEvaluationModal'
export * from './GameBox'
export * from './Input'
export * from './Loader'
export * from './MaskedInput'
export * from './MixPanel'
export * from './NewPatientModal'
export * from './Note'
export * from './OnlineDetect'
export * from './PageTitle'
export * from './ParentalInstructions'
export * from './PopoverButton'
export * from './PopupLoader'
export * from './Publication'
export * from './RadioInput'
export * from './RoleSelector'
export * from './Select'
export * from './Session'
export * from './Statistic'
export * from './StatisticBlock'
export * from './Subtitle'
export * from './VerifyEmailModal'
export * from './WhiteLink'
export * from './CongratulationsModal'
export * from './CreateChildModal'
export * from './GameInstallationModal'
export * from './WelcomeModal'
export * from './UserListener'
export * from './TempEvalStatusModal'
export * from './ConnectionProblemModal'
export * from './NewScoreModal'
export * from './ActivitiesModal'
export * from './ActivitiesComponent'
export * from './PaymentComponent'
export * from './PaymentSaveCardComponent'
export * from './PlusUserListener'
export * from './GetNumberWindow'
export * from './PlusOnlyPopup'
export * from './Logo'
export * from './Icons'

export { default as TeachersModal } from './TeachersModal'
export { default as InfoModal } from './InfoModal'
export { default as ShareModal } from './ShareModal'
export { default as ShareWithTeacherModal } from './ShareWithTeacherModal'
export { default as Circle } from './Circle'
export { default as ReavaluateModal } from './ReavaluateModal'
export { default as EvaluationWarningModal } from './EvaluationWarningModal'
export { default as HistoryModal } from './HistoryModal'
export { default as Children } from './Children'
export { default as Drawer } from './Drawer'
export { default as Header } from './Header'
export { default as HeaderDetail } from './HeaderDetail'
export { default as Question } from './Question'
export { default as Snackbars } from './Snackbars'



// WEBPACK FOOTER //
// ./src/components/index.ts